import { Link } from 'react-router-dom';
import styled from 'styled-components';

const FooterWrapper = styled.footer`
  background: #1a0f07;
  color: #aaa;
  padding: 40px;
`;

const FooterGrid = styled.div`
  display: flex;
  gap: 40px;
  flex-wrap: wrap;
  margin-bottom: 30px;
`;

const BrandName = styled.div`
  color: white;
  font-size: 1.1rem;
  font-weight: bold;
  font-family: serif;
  margin-bottom: 10px;
`;

const BrandText = styled.p`
  font-size: 0.85rem;
  font-family: sans-serif;
  line-height: 1.6;
`;

const ColTitle = styled.div`
  color: white;
  font-weight: bold;
  font-size: 0.9rem;
  font-family: sans-serif;
  margin-bottom: 14px;
`;

const ColLink = styled(Link)`
  color: #aaa;
  text-decoration: none;
  font-size: 0.85rem;
  font-family: sans-serif;
  display: block;
  margin-bottom: 8px;
`;

const ColText = styled.div`
  color: #aaa;
  font-size: 0.85rem;
  font-family: sans-serif;
  margin-bottom: 8px;
`;

const BottomBar = styled.div`
  border-top: 1px solid #333;
  padding-top: 20px;
  font-size: 0.8rem;
  font-family: sans-serif;
  text-align: center;
`;

function Footer() {
  return (
    <FooterWrapper>
      <FooterGrid>

        <div>
          <BrandName>Prestige</BrandName>
          <BrandText>
            Discover exceptional properties in Egypt's most prestigious locations.
            Your dream home awaits.
          </BrandText>
        </div>

        <div>
          <ColTitle>Quick Links</ColTitle>
          <ColLink to="/">Home</ColLink>
          <ColLink to="/properties">Properties</ColLink>
          <ColLink to="/about">About Us</ColLink>
          <ColLink to="/contact">Contact</ColLink>
        </div>

        <div>
          <ColTitle>Locations</ColTitle>
          <ColText>New Cairo</ColText>
          <ColText>Sheikh Zayed</ColText>
          <ColText>North Coast</ColText>
          <ColText>6th of October</ColText>
          <ColText>Heliopolis</ColText>
        </div>

        <div>
          <ColTitle>Contact Us</ColTitle>
          <ColText>📍 New Cairo, Cairo, Egypt</ColText>
          <ColText>📞 +20 123 456 789</ColText>
          <ColText>✉ info@prestigeestate.eg</ColText>
        </div>

      </FooterGrid>

      <BottomBar>
        © 2026 PrestigeEstate. All rights reserved.
      </BottomBar>
    </FooterWrapper>
  );
}

export default Footer;